import {Col, Row} from "react-bootstrap";
import React from "react";
import {trans} from "../../../../../../translations/translations";

const HappyAdvice1 = () => {
    return (
        <Row className={"response-row"}>
            <Col xs={12} className={"title mb-2"}>
                <p className={"m-0"}>
                    <span className={"me-1"}>{trans('results.answer3.happy.advice1.title.text1', 'sos')}</span>
                    <span className={"me-1 text-pink text-bold"}>{trans('results.answer3.happy.advice1.title.text2', 'sos')}</span>
                </p>
            </Col>
            <Col xs={12} className={"text-result mb-3"}>
                <p className={"m-0"}>{trans('results.answer3.happy.advice1.sub.text1', 'sos')}</p>
                <p className={"m-0"}>{trans('results.answer3.happy.advice1.sub.text2', 'sos')}</p>
            </Col>
        </Row>
    )
}

export default HappyAdvice1;
